import { WoosmapType } from '../types/commons';

/**
 * Types to exclude from Woosmap autocomplete for customer address.
 * Acceptance criteria: addresses without number (type route) are not shown;
 * addresses with number (type address) are shown.
 */
export const CUSTOMER_AUTOCOMPLETE_EXCLUDED_TYPES: WoosmapType[] = ['route'];
export const SUPPORTED_WOOSMAP_ADDRESS_TYPE: WoosmapType = 'address';
